import React,{useState, useEffect} from "react"
import './styles/App.css';
import NavbarContainer from './components/NavbarContainer'
import {BrowserRouter as Router, Routes, Route} from "react-router-dom"
import SearchContainer from "./components/SearchContainer"
import 'bootstrap/dist/css/bootstrap.min.css';
import ProductsGenrateor from './ProductsGenrateor'

import Home from "./components/Home";
import Navs from "./components/Navs";
import Login from './components/Login'
import About from "./components/About";
import Footer from "./components/Footer";
import Product from "./components/Product";
import Register from "./components/Register";
import ProductsContainer from "./components/ProductsContainer";
import { Container, Col, Row } from "react-bootstrap";
function App() {
  const [search, setSearch] = useState("")
  
  return (
    <Router>
    <div className="App">
      <NavbarContainer setSearch={setSearch}/>      
      <Container fluid className="pe-lg-5">
      <Row>
      <Col lg={2}>
        <Navs setSearch={setSearch} />
      </Col>
      <Col lg={10}>
      <SearchContainer displayState={window.location.pathname.includes("signup") ? "none" :"block"}/>
      <Routes>
        <Route path="/" exact element={<Home setSearch={setSearch} productsData={ProductsGenrateor}/>}/>
        <Route path="/products" exact element={<ProductsContainer productsData={ProductsGenrateor}/>}/>
        <Route path={`/products/${search.replace(/ /g, "%20")}`} element={<ProductsContainer productsData={ProductsGenrateor.filter(el => el.tag === search)} search={search}/>}/>
        {/* <Route path="/products/:title"  element={<ProductsContainer productsData={ProductsGenrateor.filter(el => el.tag === search)}/>}/> */}
        <Route path="/product/:id"  element={<Product productsData={ProductsGenrateor}/>}/>
        <Route path="/about"  element={<About />}/>
        <Route path="/login"  element={<Login />}/>
        <Route path="/register"  element={<Register />}/>
      </Routes>
      <Footer />
      </Col>
      </Row>
      </Container>
      </div>
    </Router>
  );
}

export default App;
